import React, { useEffect, useState } from "react";
import { Form, Table, Image, Button, Row, Col } from "react-bootstrap";
import { isAdmin, isPermited } from "../../../../features/localStorage";
import Save from "../../../../assets/images/save-line.svg";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { GetinsertEthicsTeamGroupDetails } from "../../../../features/helpandassistance/insertEthicsTeamGroupDetailsSlice";
import { GetContacts } from "../../../../features/helpandassistance/contactsSlice";
import { useForm } from "react-hook-form";
import swal from "sweetalert";
import { GetDeleteEthicsTeamGroupDetails } from "../../../../features/helpandassistance/deleteEthicsTeamGroupDetailsSlice";
import { GetDeleteEthicsTeamGroup } from "../../../../features/helpandassistance/deleteEthicsTeamGroupSlice";
import Delete from "../../../../assets/images/ic-deletebox.svg";
import DeleteBox from "../../../../assets/images/ic-deletebox2.svg";
import DeleteBox1 from "../../../../assets/images/ic-deletebox.svg";
import Add from "../../../../assets/images/ic-add.svg";
import Add2 from "../../../../assets/images/ic-add3.svg";
// Messages
const required = "This field is required";
const pattern = "Please insert valid input";
// Error Component
const errorMessage = (error: any) => {
  return <div className="invalid-feedback">{error}</div>;
};
const TableList = ({
  tData,
  id,
  checkDeleteGroupDetailsId,
  checkListShow,
  searchData,
  setGroupId,
}: {
  tData: any;
  id: any;
  checkDeleteGroupDetailsId: any;
  checkListShow: any;
  searchData: string;
  setGroupId: any;
}) => {
  const [MasterChecked, setMasterChecked] = useState(false);
  const [SelectedList, setSelectedList] = useState([]);
  const [List, setList] = useState(tData);
  const [tempList, setTempList] = useState(tData);
  const [selectedIds, setSelectedIds] = useState();

  const [recordRow, setRecordRow] = useState(false);
  const [saveButton, setSaveButton] = useState(false);
  const [toggleDelete, setToggleDelete] = useState(false);
  const [groupDetailsId, setGroupDetailsId] = useState();
  var searchParams = {
    companyId: 0,
    keyword: searchData,
  };
  const [name, setName] = useState("");
  const [role, setRole] = useState("");
  const [designation, setDesignation] = useState("");
  const dispatch = useAppDispatch();
  const { register, handleSubmit, errors } = useForm();
  const onSubmit = async (event: any) => {
    // event.preventDefault();
    var postdata = {
      name: name,
      role: role,
      designation: designation,
      groupId: id,
    };
    var data = {
      data: postdata,
      id: id,
    };
    await dispatch(GetinsertEthicsTeamGroupDetails(data));
    await dispatch(GetContacts(searchParams));
    setName("");
    setRole("");
    setDesignation("");
    setRecordRow(false);
    //await window.location.reload()
    // setList([...newList]);
  };
  const onMasterCheck = async (e: React.ChangeEvent<HTMLInputElement>) => {
    //await checkDeleteGroupDetailsId(List.map((e:any) => e.id))
    let newList = tempList.map((obj: any) =>
      Object.assign({}, obj, { selected: e.target.checked })
    );
    //console.log(List.map((e:any) => e.id),"onMasterCheck")
    setMasterChecked(e.target.checked);
    setList(newList);
    setTempList(newList);
    await setSelectedList(newList.filter((e: any) => e.selected));
    await setGroupDetailsId(newList.map((e: any) => e.id));
  };

  const newMappedList = (data: any, item: any, checked: boolean) => {
    //console.log(data,item,checked, "newMapedList")
    let newData = data.map((obj: any) => {
      let selected = false; //obj.selected
      if (obj.id === item.id) {
        selected = checked;
      } else {
        selected = obj?.selected ? obj.selected : false;
      }
      return {
        ...obj,
        selected: selected,
      };
    });
    return newData;
  };

  const onItemCheck = async (
    e: React.ChangeEvent<HTMLInputElement>,
    item: any
  ) => {
    //console.log(item, "onItemCheck")
    let newList = newMappedList(tempList, item, e.target.checked);

    const totalItems = newList.length;
    const totalCheckedItems = newList.filter((e: any) => e.selected).length;

    setMasterChecked(totalItems === totalCheckedItems);
    setList(newList);
    setTempList(newList);
    //console.log(List.filter((e:any) => e.selected),"List.filter((e:any) => e.selected)")
    setSelectedList(newList.filter((e: any) => e.selected));
    await setGroupDetailsId(newList.map((e: any) => e.id));
    // let filtredRecords: any[] = newList.filter((e: any) => e.selected);
    // let newArray = filtredRecords.map({id} => id);

    // setGroupDetailsId([...newArray]);
  };

  const getSelectedRows = () => {
    setSelectedList(List.filter((e: any) => e.selected));
  };
  useEffect(() => {
    // alert(checkListShow)
    async function fetchLocationData() {
      //console.log(SelectedList,"SelectedListSelectedList");
      await checkDeleteGroupDetailsId(SelectedList.map((e: any) => e.id));
    }
    fetchLocationData();
    setGroupId(id);
  }, [SelectedList, groupDetailsId, tData]);
  const onAddRecord = () => {
    setRecordRow(true);
  };
  const onDeleteGroupDetails = async () => {
    swal({
      title: "Are you sure delete record?",
      text: "Once deleted, you will not be able to recover this record",
      icon: "warning",
      dangerMode: true,
    }).then(async (willDelete: any) => {
      if (willDelete) {
        swal(" Your record has been deleted!", {
          icon: "success",
        });
        let toBeDeleteArray = SelectedList.map((obj: any) => {
          return obj?.id;
        });
        let tobeDeleteString = toBeDeleteArray.join(",");
        await dispatch(GetDeleteEthicsTeamGroupDetails(tobeDeleteString));
        await dispatch(GetContacts(searchParams));
        // await window.location.reload()
        // setList([...newList]);
      } else {
        swal("Your record is safe!");
      }
    });
  };
  const onDeleteGroup = () => {
    var data = {
      id: id,
    };
    swal({
      title: "Are you sure delete record?",
      text: "Once deleted, you will not be able to recover this record",
      icon: "warning",
      dangerMode: true,
    }).then(async (willDelete: any) => {
      if (willDelete) {
        swal(" Your record has been deleted!", {
          icon: "success",
        });
        await dispatch(GetDeleteEthicsTeamGroup(data));
        await dispatch(GetContacts(searchParams));
        await window.location.reload();
      } else {
        swal("Your record is safe!");
      }
    });
  };
  return (
    <>
      {isPermited(8, 2) && (
        <>
          {checkListShow === false ? (
            <Row>
              {saveButton !== true ? (
                <>
                  <Col sm={6}>
                    <span style={styles.deletecompany}>
                      <a style={styles.link} onClick={onDeleteGroup}>
                        <Image src={Delete} /> DELETE COMPANY
                      </a>
                    </span>
                  </Col>
                  <Col
                    sm={1}
                    className="ms-auto mb-3"
                    onClick={() => setToggleDelete(!toggleDelete)}
                  >
                    <Image src={Add2} onClick={onAddRecord} />
                    {groupDetailsId === undefined ? (
                      <Image
                        src={DeleteBox}
                        onClick={onDeleteGroupDetails}
                        className="float-end logo-img"
                        alt="Logo1"
                      />
                    ) : (
                      <Image
                        src={DeleteBox1}
                        onClick={onDeleteGroupDetails}
                        className="float-end logo-img"
                        alt="Logo"
                      />
                    )}
                  </Col>
                </>
              ) : null}
            </Row>
          ) : null}
        </>
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="grid">
          <div className="grid-container">
            <Table style={styles.border} responsive>
              <thead>
                <tr>
                  {isPermited(8, 2) && (
                    <>
                      {checkListShow === false ? (
                        <th className="pe-0" style={{ width: "1px" }}>
                          <Form.Check
                            type="checkbox"
                            checked={MasterChecked}
                            id="mastercheck"
                            onChange={(e) => onMasterCheck(e)}
                          />
                        </th>
                      ) : null}
                    </>
                  )}
                  <th className="py-3 ps-3" style={styles.tableHeading}>
                    Sr. No.
                  </th>
                  <th className="py-3 ps-3" style={styles.tableHeading}>
                    Name
                  </th>
                  <th className="py-3 ps-3" style={styles.tableHeading}>
                    Role
                  </th>
                  <th className="py-3 ps-3" style={styles.tableHeading}>
                    Designation
                  </th>
                </tr>
              </thead>
              <tbody>
                {recordRow === true ? (
                  <>
                    <tr style={{ borderBottom: "none !important" }}>
                      <td className="pe-0" style={{ width: "1px" }}></td>
                      <td
                        className="pe-0 ps-0"
                        style={styles.tableHeading}
                      ></td>
                      <td className="py-3 ps-0" style={styles.tableHeading}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            style={styles.textfield}
                            value={name}
                            ref={register({
                              required: true,
                            })}
                            name="name"
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setName(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Name <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.name &&
                          errors.name.type === "required" &&
                          errorMessage(required)}
                        {/* {errors.name &&
                          errors.name.type === "pattern" &&
                          errorMessage(pattern)} */}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableHeading}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            style={styles.textfield}
                            value={role}
                            name="role"
                            ref={register({
                              required: true,
                            })}
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setRole(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Role <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.role &&
                          errors.role.type === "required" &&
                          errorMessage(required)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableHeading}>
                        <div className="helpfloating-label-group">
                          <input
                            type="text"
                            style={styles.textfield}
                            value={designation}
                            ref={register({
                              required: true,
                            })}
                            name="designation"
                            className="helptextstyle"
                            onChange={(
                              ev: React.ChangeEvent<HTMLInputElement>
                            ): void => setDesignation(ev.target.value)}
                          />
                          <label className="helpfloating-label">
                            Designation <span style={styles.star}> * </span>
                          </label>
                        </div>
                        {errors.designation &&
                          errors.designation.type === "required" &&
                          errorMessage(required)}
                      </td>
                      <td className="py-3 ps-3" style={styles.tableHeading}>
                        <Button
                          className="mb-2"
                          type="submit"
                          style={styles.button}
                        >
                          {" "}
                          SAVE
                        </Button>
                      </td>
                    </tr>
                    {/* <tr style={styles.brdTop}>
                    
                </tr> */}
                  </>
                ) : null}

                {tData.map((val: any, index: any) => {
                  return (
                    <>
                      <tr style={styles.border} key={index + 1}>
                        {isPermited(8, 2) && (
                          <>
                            {checkListShow === false ? (
                              <td className="pe-0" style={{ width: "1px" }}>
                                <Form.Check
                                  type="checkbox"
                                  checked={val.selected}
                                  id="rowcheck{val.id}"
                                  onChange={(e) => onItemCheck(e, val)}
                                />
                              </td>
                            ) : null}
                          </>
                        )}

                        <td className="py-3 ps-3" style={styles.tableContents}>
                          {index + 1}
                        </td>
                        <td className="py-3 ps-3" style={styles.tableContents}>
                          {val.name}
                        </td>
                        <td className="py-3 ps-3" style={styles.tableContents}>
                          {val.role}
                        </td>
                        <td className="py-3 ps-3" style={styles.tableContents}>
                          {val.designation}
                        </td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </form>
    </>
  );
};

const styles: any = {
  button: {
    padding: "8px 30px",
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: 400,
    fontStretch: "normal",
    fontStyle: "normal",
    borderRadius: "0",
    backgroundColor: "#e31837",
    letterSpacing: "normal",
    border: "0px",
  },
  link: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
    color: "#e31837",
    lineHeight: "2",
    textTransform: "uppercase",
    textDecoration: "none",
  },
  star: { color: "#e31837" },
  brdBottom: {
    borderBottom: "1px solid #fff",
  },
  brdTop: {
    borderTop: "1px solid #fff",
  },
  textfield: {
    width: "80%",
  },

  save: { color: "#e31837", fontSize: "12px" },

  divWhite: {
    backgroundColor: "#fffff",
    padding: "24px",
  },
  tableHeading: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "600",
  },
  tableContents: {
    fontFamily: "Saira",
    fontSize: "12px",
    fontWeight: "normal",
  },
  border: {
    border: "solid 1px #e4e4e4",
  },
};

export default TableList;
